// OneDrive:IgnoreCodeCoverage

import { createSingleEvent } from '../SingleEventBase';
import { IEventType } from '../EventBase';
import { IEvent, EventFieldType } from '../IEvent';
import { ExperimentTypeEnum } from './ExperimentTypeEnum';

export interface IExperimentSingleSchema {
    /**
     * The feature name
     */
    name: string;
    /**
     * True if the user is in the ramp, false if they are not
     */
    isInRamp: boolean;
    /**
     * This is the name of the experiment the user is currently part of
     */
    experiment: string;
    /**
     * This is the name of the variant in the experiment the user is currently part of
     */
    variant: string;
    /**
     * This is the type of assignment used in the experiment
     */
    assignmentType?: ExperimentTypeEnum;
    /**
     * This is the ID used for assignment in the experiment
     */
    assignmentId?: string;
}

export interface IExperiment extends IEvent {
    data: IExperimentSingleSchema;
}

export type Experiment = IExperiment;

export const Experiment: IExperimentType = createSingleEvent<IExperimentSingleSchema>({
    eventName: 'Experiment,',
    shortEventName: 'Experiment'
}, {
        name: {
            isPrefixingDisabled: true,
            type: EventFieldType.String
        },
        isInRamp: {
            isPrefixingDisabled: true,
            type: EventFieldType.Boolean
        },
        experiment: {
            isPrefixingDisabled: true,
            type: EventFieldType.String
        },
        variant: {
            isPrefixingDisabled: true,
            type: EventFieldType.String
        },
        assignmentType: {
            isPrefixingDisabled: true,
            type: EventFieldType.Enum,
            typeRef: ExperimentTypeEnum
        },
        assignmentId: {
            isPrefixingDisabled: true,
            type: EventFieldType.String
        }
    });

export interface IExperimentType extends IEventType<IExperimentSingleSchema> {
    prototype: Experiment;
    /**
     * This will create a single Experiment event
     * @param data {IExperimentSingleSchema}     * -required name - The feature name
     * -required isInRamp - True if the user is in the ramp, false if they are not
     * -required experiment - This is the name of the experiment the user is currently part of
     * -required variant - This is the name of the variant in the experiment the user is currently part of
     * @param parent {IEvent} The optional parent for this event
     */
    logData(this: typeof Experiment, data?: IExperimentSingleSchema, parent?: IEvent): Experiment;
}

export default Experiment;
